/**
 * PDP variant detail images — show/hide pre-rendered PC/mobile panels.
 * Listens to ts:variant:change from section-product-header.
 */
(function () {
  'use strict';

  function getRoots() {
    return document.querySelectorAll('[data-variant-detail-root]');
  }

  function showPanel(root, variantId) {
    if (!root || variantId == null || variantId === '') return;
    const id = String(variantId);
    const panels = root.querySelectorAll('[data-variant-detail-panel]');
    const fallback = root.querySelector('[data-variant-detail-fallback]');
    let matched = false;
    panels.forEach(function (panel) {
      const on = panel.getAttribute('data-variant-id') === id;
      panel.hidden = !on;
      if (on) matched = true;
    });
    if (fallback) fallback.hidden = matched;
  }

  function syncAll(variantId) {
    getRoots().forEach(function (root) {
      showPanel(root, variantId);
    });
  }

  function variantIdFromUrl() {
    try {
      return new URL(window.location.href).searchParams.get('variant');
    } catch (e) {
      return null;
    }
  }

  function onVariantChange(event) {
    const variant = event.detail && event.detail.variant;
    if (variant == null || variant.id == null) return;
    syncAll(variant.id);
  }

  function syncFromUrl() {
    const id = variantIdFromUrl();
    if (id) syncAll(id);
  }

  document.addEventListener('ts:variant:change', onVariantChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromUrl);
  } else {
    syncFromUrl();
  }

  window.addEventListener('pageshow', syncFromUrl);
})();
